import { render } from "./PasesLibres..vue?vue&type=template&id=e74637e6"
import script from "./PasesLibres..vue?vue&type=script&lang=js"
export * from "./PasesLibres..vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__